import { defineRoute } from '../defineRoute';

export type GlobalListingSearchRouteParams = {
  // ...
};

export type GlobalListingSearchRouteParamsString = {
  // ...
};

export const GlobalListingSearch = defineRoute<
  GlobalListingSearchRouteParams,
  GlobalListingSearchRouteParamsString
>({
  pathname: '/for-rent/properties-netherlands',
  nlPathname: '/huren/huurwoningen-nederland',
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
